/* eslint-disable @typescript-eslint/ban-types */
import {
    FunctionsObject,
    ObjectPropsWithType,
    ReturnTypes,
} from '@superbet-group/web.lib.utilities';
import { NavigationDestination } from '@app/router/types';

export type VueGlobals = {
    $t: (path: string) => string;
};

export type MixinPropsDefinition<
    TData = {},
    TComputed extends FunctionsObject = {},
    TMethods extends FunctionsObject = {},
> = {
    data: {} extends TData ? void : () => TData;
    computed: {} extends TComputed ? void : TComputed;
    methods: {} extends TMethods ? void : TMethods;
};

export type MixinDefinition<
    TData,
    TComputed extends FunctionsObject,
    TMehods extends FunctionsObject,
> = Omit<
    MixinPropsDefinition<TData, TComputed, TMehods>,
    ObjectPropsWithType<
        MixinPropsDefinition<TData, TComputed, TMehods>,
        void
    >
> & {
    mixins?: any[]; // typescript doesn't support self-referential types
};

export type Mixin<TData, TComputed extends FunctionsObject, TMethods extends FunctionsObject> =
    TData & ReturnTypes<TComputed> & TMethods & VueGlobals;

export const BottomBarItemId = {
    Home: 'Home',
    Sport: 'Sport',
    SportPrematch: 'SportPrematch',
    Live: 'Live',
    Promotions: 'Promotions',
    CardGames: 'Card Games',
    MyTickets: 'My Tickets',
    Shops: 'Shops',
    MyCasino: 'My Casino',
} as const;
export type BottomBarItemId = typeof BottomBarItemId[keyof typeof BottomBarItemId];

export type BottomBarItem = {
    id: BottomBarItemId;
    destination?: NavigationDestination;
    icon: string;
    name: string;
    isSelected: boolean;
    dynamic?: boolean;
};

export type HeaderItem = {
    name: string;
    e2eClass: string;
    destination: NavigationDestination;
    useActiveClass?: boolean;
    additionalClasses?: Record<string, boolean>;
    liveEventsCount?: number;
    displayMenuItem?: boolean;
    isDynamic?: boolean;
};
